__turbopack_context__.v({
  "card": "_0EdUlW_card",
  "footer": "_0EdUlW_footer",
  "header": "_0EdUlW_header",
  "headerTitle": "_0EdUlW_headerTitle",
  "headerTitleText": "_0EdUlW_headerTitleText",
  "icon": "_0EdUlW_icon",
  "list": "_0EdUlW_list",
  "viewAll": "_0EdUlW_viewAll",
  "viewFeed": "_0EdUlW_viewFeed",
});
